/* Copyright (c) 2020-present CloudIO Inc */

import { ShowMsgItem } from 'componentregistry/platform/Platform';

export default class IOError extends Error {
  name = 'IOError';

  title: string;

  code: string | null | undefined;

  item?: ShowMsgItem;

  constructor(title: string, message: string, code?: string) {
    super(message);
    this.title = title;
    this.code = code;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, IOError);
    }
  }

  withItem(item?: ShowMsgItem) {
    this.item = item;
    return this;
  }
}
